<div class="content">
  <div class="title">工单提交成功</div>
  <div mat-dialog-content class="detail">
    <div class="part1">
      <div class="txt1">
        <img
          src="../../../../../../assets/images/holiday/bell.png"
          alt=""
        />春节假期公告：
      </div>
      <div class="txt2">
        环球巴士 于<span> 2月15日-2月22日 </span>休假，并于<span>
          2月22日
        </span>
        恢复正常办公。
      </div>
    </div>
    <div class="part2">
      我们将在<span> 2月22日 恢复正常办公 </span>后按顺序为您解答
    </div>
    <div class="part2">祝您生活愉快！</div>
  </div>
  <div class="btn">
    <button matRipple (click)="close()">确定</button>
  </div>
</div>
